import React, { useState, useEffect } from 'react';
import * as moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  Table,
  TableHead,
  TableBody,
  Grid,
  TableRow,
  TableCell,
  CircularProgress,
} from '@material-ui/core';
import Button from '../../../components/Button';
// import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
// import ApptReqPreviewModal from './ApptReqPreviewModal';
// import ApptRequestAttachmentModal from './ApptRequestAttachmentModal';
import { fetchPatientReferrals } from '../../../services/api';
import * as portalApi from '../../../services/api/portal';

function PatientApptRequest(props) {
  const {
    patientId,
    history,
    classes: { tableTitle, tableContainer, button },
  } = props;

  const enqueueSnackbar = useSnackbar();
  const pageLimit = 10;

  const [isLoading, setIsLoading] = useState(false);
  const [apptReqs, setApptReqs] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        await patientRequestReferrals();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's requests and referrals");
      }
      setIsLoading(false);
    })();
  }, []);

  const patientRequestReferrals = async () => {
    const newWayRequests = await fetchPatientReferrals(patientId);
    const oldWayRequests = await portalApi.getPatientAppointmentRequests(
      patientId
    );

    //keeping the "by" key so that the field value is handled before the two different data structures
    //become one - as you can see, the newWayReqs' by field should always be the fromProvider name,
    //but the ogWayReqs' by field should be the sender's name or, if empty, just PATIENT.
    setApptReqs([
      ...newWayRequests.map(ref => ({
        sender: {
          fullTitle: ref.fromProvider.name,
        },
        createdAt: ref.createdAt,
        notes: ref.body,
        receiver: {
          fullTitle: ref.toProvider.name,
          providerUrl: ref.toProvider.providerUrl,
        },
        id: ref.id,
      })),
      ...oldWayRequests,
    ]);
    setIsLoading(false);
  };

  /*
   * Book appointment function redirect to Provider Profile Page
   */
  const handleBookAppointment = (e, toProviderUrl) => {
    e.stopPropagation();
    window.location.assign(
      `${process.env.REACT_APP_HOMEPAGE_URL}${toProviderUrl}`
    );
  };

  const onPageBack = async () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const onPageForward = async () => {
    setPageIndex(pageIndex + 1);
  };

  return isLoading ? (
    <div className={props.classes.loading}>
      <CircularProgress />
    </div>
  ) : (
    <>
      <Grid item xs={12} className={tableContainer}>
        <Table className="fullWidth">
          <TableHead>
            <TableRow className="col-4-th">
              <TableCell className={tableTitle}>Requested by</TableCell>
              <TableCell className={tableTitle}>Requested with</TableCell>
              <TableCell className={tableTitle}>Requested At</TableCell>
              <TableCell className={tableTitle}>Notes</TableCell>
              <TableCell className={tableTitle} />
            </TableRow>
          </TableHead>
          <TableBody>
            {apptReqs &&
              apptReqs.map(appointmentRequest => (
                <TableRow key={appointmentRequest.id}>
                  <TableCell>
                    {appointmentRequest &&
                    appointmentRequest.sender &&
                    appointmentRequest.sender.fullTitle
                      ? appointmentRequest.sender.fullTitle
                      : patientId.isDependent
                      ? 'GUARDIAN'
                      : 'PATIENT'}
                  </TableCell>
                  <TableCell width="300px">
                    {appointmentRequest &&
                      appointmentRequest.receiver &&
                      appointmentRequest.receiver.fullTitle}
                  </TableCell>
                  <TableCell>
                    {moment(appointmentRequest && appointmentRequest.createdAt)
                      .tz('America/New_York')
                      .format('MM/DD/YYYY hh:mma z')}
                  </TableCell>
                  <TableCell width="300px">
                    {appointmentRequest && appointmentRequest.notes}
                  </TableCell>
                  <TableCell className="book-appoint-sm">
                    <Button
                      onClick={event =>
                        handleBookAppointment(
                          event,
                          appointmentRequest &&
                            appointmentRequest.receiver &&
                            appointmentRequest.receiver.providerUrl
                        )
                      }
                      className={button}
                    >
                      Book Appointment
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Grid>
    </>
  );
}

PatientApptRequest.propTypes = {
  patient: PropTypes.object,
};

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    backgroundColor: '#0277bd',
    color: 'white',
    '&:visited': {
      color: 'white',
    },
  },
  customSpacing: {
    marginLeft: '21px',
    display: 'block',
  },
  tableTitle: {
    fontSize: '0.7rem',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  tableContainer: {
    overflowX: 'auto',
  },
});

export default withStyles(styles)(PatientApptRequest);
